import type { AuthValue } from '@elfsight/configurator-contracts';
import { meta } from '../../../../constants';
import type { DemoSourceType } from '../types';
import type { VKontakteSourceValue } from './types';

const previewVkontakteAuth: AuthValue = {
  identity: 'c8309b96-3d71-4255-be1b-58695615d1b8',
  data: { name: 'Max Isaev', nickname: 'maxisaev' },
  status: 'connected'
};

const extraVkontakteSources: DemoSourceType<VKontakteSourceValue> = {
  'vk-wearefabulous': {
    label: 'VK: @wearefabulous',
    source: {
      authentication: previewVkontakteAuth,
      platform: 'vkontakte',
      connectionType: 'vkontakteGroup',
      id: 'kkpb571v',
      name: 'VK',
      source: 'https://vk.com/wearefabulous'
    }
  },
  'vk-thisiscolossal': {
    label: 'VK: @thisiscolossal',
    source: {
      authentication: previewVkontakteAuth,
      platform: 'vkontakte',
      connectionType: 'vkontakteGroup',
      id: 'kkpb5i0j',
      name: 'VK',
      source: 'https://vk.com/thisiscolossal'
    }
  },
  'vk-ted': {
    label: 'VK: @ted',
    source: {
      authentication: previewVkontakteAuth,
      platform: 'vkontakte',
      connectionType: 'vkontaktePublic',
      id: 'kkpb5oxa',
      name: 'VK',
      source: 'https://vk.com/public50348171'
    }
  },
  'vk-victoriaasecret': {
    label: 'VK: @victoriaasecret',
    source: {
      authentication: previewVkontakteAuth,
      platform: 'vkontakte',
      connectionType: 'vkontakteGroup',
      id: 'kkpb62b8',
      name: 'VK',
      source: 'https://vk.com/victoriaasecret'
    }
  },
  'vk-inna_ro': {
    label: 'VK: @inna_ro',
    source: {
      authentication: previewVkontakteAuth,
      platform: 'vkontakte',
      connectionType: 'vkontakteGroup',
      id: 'kkpb68nx',
      name: 'VK',
      source: 'https://vk.com/inna_ro'
    }
  }
};

export const previewVkontakteSources: DemoSourceType<VKontakteSourceValue> = {
  'vk-durov': {
    label: 'VK: @durov',
    source: {
      platform: 'vkontakte',
      connectionType: 'vkontakteProfile',
      id: 'kkpb571v',
      name: 'VK',
      authentication: previewVkontakteAuth,
      source: 'https://vk.com/durov'
    }
  },
  'vk-seriousscience': {
    label: 'VK: @seriousscience',
    source: {
      platform: 'vkontakte',
      connectionType: 'vkontakteGroup',
      id: 'kgte621u',
      name: 'VK',
      authentication: previewVkontakteAuth,
      source: 'https://vk.com/seriousscience'
    }
  },
  'vk-technologytoolz': {
    label: 'VK: @technologytoolz',
    source: {
      platform: 'vkontakte',
      connectionType: 'vkontaktePublic',
      id: 'kkpb44j5',
      name: 'VK',
      authentication: previewVkontakteAuth,
      source: 'https://vk.com/public61388532'
    }
  },
  ...(meta.alias === 'vk-feed' ? extraVkontakteSources : {})
};
